import { Spacer } from '@components/Spacer'
import { Widget as GoalsWidget } from '@features/goals'
import Salutation from '@features/home/components/Salutation'
import { ProfilePic } from '@features/profile/components/ProfilePic'
import { StoriesWidget } from '@features/stories/components/StoriesWidget'
import { analytics } from '@services/Analytics'
import * as Colors from '@themes/Colors'
import * as React from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import { useRouter } from 'solito/navigation'
import { useAuthContext } from '~/features/auth/components/AuthProvider'
const ENABLE_UPDATES = false

export function HomeScreenHeader() {
  const { user } = useAuthContext()
  const router = useRouter()

  const handleProfileClick = () => {
    analytics.track('Profile Click', {})
    router.push('/profile')
  }

  return (
    <View style={styles.container}>
      <View style={styles.headerTop}>
        <View style={styles.welcomeSection}>
          <Salutation firstName={user?.firstName} />
        </View>

        <View style={styles.profileSection}>
          {user && (
            <Pressable
              style={({ pressed, hovered }) => [
                styles.profileButton,
                {
                  opacity: pressed ? 0.7 : hovered ? 0.9 : 1,
                },
              ]}
              onPress={handleProfileClick}
            >
              <ProfilePic hideBorder={true} size={40} />
            </Pressable>
          )}
        </View>
      </View>

      <View style={styles.contentSection}>
        <GoalsWidget />
        <Spacer noShrink height={12} />
        <StoriesWidget />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    width: '100%',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: Colors.altWhite,
  },
  headerTop: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  welcomeSection: {
    flex: 1,
  },
  profileSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  profileButton: {
    padding: 4,
    borderRadius: 20,
    backgroundColor: Colors.altWhite,
  },
  contentSection: {
    marginTop: 4,
  },
})
